module.exports = __webpack_public_path__ + "img/free-trial-icon.101cc2e1.svg";